import { useEffect, useRef } from 'react';

import { TradeInStepName } from '../../types';
import { stepNameToRouteMap, tradeInRoutes } from '../../utils';

export const useStepChange = (pathname: string, onStepChange: (s: TradeInStepName) => void) => {
    const prevStepRef = useRef<TradeInStepName | undefined>(undefined);

    useEffect(() => {
        if (!tradeInRoutes.includes(pathname)) {
            prevStepRef.current = undefined;
            return;
        }

        const stepNameToRoute = Object.entries(stepNameToRouteMap).find(([, sRoutes]) =>
            sRoutes.includes(pathname),
        ) as [TradeInStepName, string[]] | undefined;

        if (!stepNameToRoute) return;

        const [stepName] = stepNameToRoute;

        if (prevStepRef.current !== stepName) {
            prevStepRef.current = stepName;
            onStepChange(stepName);
        }
    }, [pathname, onStepChange]);
}
